// extracted by mini-css-extract-plugin
export var deleteModal = "_gs-0";